import { TPayment } from "./TPayment"
export type TProviderType = "PspAndAquirer" | "Psp" | "Aquirer" | "Other"
export type TProviderName =
    | "Swiipe"
    | "Clearhaus"
    | "Bambora"
    | "DankortEpay"
    | "Finaro"
    | "ForbrugsforeningenEpay"
    | "MobilePayOnline"
    | "Swish"
    | "Viabill"
    | "Anyday"
    | "Vipps"
    | "Klarna"
    | "Resurs"
    | "ApplePay"
    | "AccountToAccount"
    | "Digiteal"
    | "PaymentIQ"
    | "Area42"

export type TAcquirerName =
    | "Nets"
    | "Clearhaus"
    | "Forbrugsforeningen"
    | "Swish"
    | "Viabill"
    | "Anyday"
    | "Klarna"
    | "Resurs"
    | "Digiteal"
    | "VippsMobilePay"
    | "Area42"

export type TOnboardingStatus = "ActionRequired" | "InProgress" | "Ready"

export interface IGatewayProvider {
    paymentType: TPayment
    providerType: TProviderType
    providerName: TProviderName
    status?: TOnboardingStatus
    enabled?: boolean
}

export enum TSwiipePlan {
    None = 0,
    Basic = 1,
    Business = 2,
}
